import { render, staticRenderFns } from "./landingFooter.vue?vue&type=template&id=2516e213"
import script from "./landingFooter.vue?vue&type=script&lang=js"
export * from "./landingFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports